import gql from 'graphql-tag'

export default gql`
{
  new_projects{
    project_id
    name
    project_status{
      project_status_id
      description
    }
    clients_as_string
    date_created
  }
}
`